// @flow

import gql from 'graphql-tag';

const switchesQuery = gql`
  query switchesQuery {
    session {
      identity
      switches
    }
  }
`;

export default switchesQuery;
